import { render, staticRenderFns } from "./WizardStepJobMatchEmailNotification.vue?vue&type=template&id=39468dc4&scoped=true&lang=pug&"
import script from "./WizardStepJobMatchEmailNotification.vue?vue&type=script&lang=ts&"
export * from "./WizardStepJobMatchEmailNotification.vue?vue&type=script&lang=ts&"
import style0 from "./WizardStepJobMatchEmailNotification.vue?vue&type=style&index=0&id=39468dc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39468dc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39468dc4')) {
      api.createRecord('39468dc4', component.options)
    } else {
      api.reload('39468dc4', component.options)
    }
    module.hot.accept("./WizardStepJobMatchEmailNotification.vue?vue&type=template&id=39468dc4&scoped=true&lang=pug&", function () {
      api.rerender('39468dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard-pages/jobmatch-steps/WizardStepJobMatchEmailNotification.vue"
export default component.exports